const host = "https://get-payqin.ew.r.appspot.com/api";
//const host = "http://localhost:8080/api";

export default host;
